import { defineNuxtPlugin } from '#app'

// define plugin
export default defineNuxtPlugin(async () => {
    return {
        provide: {
            t: (key: string | number): string => `${key}`,
        },
    }
})
